const initialState = {
    isAppeal: false,
};

const appealReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_IS_APPEAL':
            state.isAppeal = action.payload;
            return { isAppeal: state.isAppeal };
        default:
            return state;
    }
};

export default appealReducer;
